import { useCallback, useEffect } from 'react';

import log from 'loglevel';

import { useFetchCacheStore } from '../../store';
import { useFetchSlackChannels } from '../UserCommunications';

export const useSlackDataFetch = () => {
  const { handleFetchSlackChannels } = useFetchSlackChannels();
  const { markSlackChannelsAsLoaded, isSlackChannelsLoaded } =
    useFetchCacheStore();

  const onSlackDataFetch = useCallback(async () => {
    if (isSlackChannelsLoaded()) {
      log.info('Slack channels already loaded, skipping fetch');
      return;
    }

    try {
      await handleFetchSlackChannels();
      markSlackChannelsAsLoaded();
    } catch (error) {
      log.error('Error fetching Slack channels:', error);
    }
  }, [
    isSlackChannelsLoaded,
    handleFetchSlackChannels,
    markSlackChannelsAsLoaded,
  ]);

  useEffect(() => {
    onSlackDataFetch();
  }, []);
};
